<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{orderPrintModel.orderId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{orderPrintModel.orderId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{orderPrintModel.branchName}}</p>

                  <!--Nombre Pedido -->
                  <p id="nombre-pedido-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> Pedido Nro.{{orderPrintModel.consecutive}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.branchPhone}}</p>

                  <!-- Fecha Pedido -->
                  <label id="t-fecha-pedido-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-pedido' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-pedido-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.dateOrder| date: 'dd/MM/yyyy'}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{orderPrintModel.orderId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{orderPrintModel.costCenter}}</p>

                  <!-- Observación C.Costos  -->
                  <label id="t-observacion-centro-costos-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-observacion-centro-costos' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="observacion-centro-costos-{{orderPrintModel.orderId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{orderPrintModel.observationCostCenter}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-obra-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.constructionSiteAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.constructionSitePhone}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.constructionSiteClient}}</p>

                  <!--Cliente  -->
                  <label id="cliente2-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'cliente2' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente2-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.constructionSiteClient2}}</p>

                  <!-- Anunciante  -->
                  <label id="t-anunciante-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-anunciante' | formatLabelPipe : elementsLabel}}</label>
                  <p id="anunciante-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{orderPrintModel.advertiser}}</p>

                  <!-- Vendedor  -->
                  <label id="t-vendedor-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-vendedor' | formatLabelPipe : elementsLabel}}</label>
                  <p id="vendedor-{{orderPrintModel.orderId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{orderPrintModel.seller}}
                  </p>

                  <!-- Tipo Pedido  -->
                  <label id="t-tipo-pedido-{{orderPrintModel.orderId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-tipo-pedido' | formatLabelPipe : elementsLabel}}</label>
                  <p id="tipo-pedido-{{orderPrintModel.orderId}}" (click)="onClick()" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{orderPrintModel.orderType}}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-pedido-{{ orderPrintModel.orderId }}" [columns]="columns"
                  [data]="orderPrintModel.orderDetails" [idMap]="idMap" [documentId]="orderPrintModel.orderId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <div id="foot-{{orderPrintModel.orderId}}" class="foot mt-3 container-observations">
                <label id="t-observaciones-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-observaciones' | formatLabelPipe : elementsLabel}}</label>

                <p id="observacion-pedido-{{orderPrintModel.orderId}}" class="lh-sm observation-pedido"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()" *ngIf="orderPrintModel.observation">
                  {{ orderPrintModel.observation }}
                </p>

                <label id="t-observacion-remision-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-observacion-remision' | formatLabelPipe : elementsLabel}}</label>

                <p id="observacion-remision-{{orderPrintModel.orderId}}" class="lh-sm observation-remision"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="orderPrintModel.observationRemission">
                  {{ orderPrintModel.observationRemission }}
                </p>

                <!-- Firma Recibido-->
                <p id="linea-firma-recibido-{{orderPrintModel.orderId}}" class="write-line" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                <label id="t-firma-recibido-{{orderPrintModel.orderId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'t-firma-recibido' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{orderPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>